import React, { useMemo } from 'react';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import CaptionTable from "components/general/table/CaptionTable";
import Label from "components/general/Label"
import MirsTable from "components/general/table/Table";
import SportCode from 'components/common/SportCode';
import { ResultCompetitor } from 'components/presentation/ResultRank'
import Competitors from "components/presentation/Competitor"
import Noc from "components/presentation/Noc";

function SalRaceIncidents({ data, numRows  }) {
  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()

  let actions
  if (numRows) {
      actions = data?.results?.playByPlay && data?.results?.playByPlay[0].actions.sort((a, b) => b.pbpa_order - a.pbpa_order).slice(0, numRows)
  } else {
      actions = data?.results?.playByPlay && data?.results?.playByPlay[0].actions.sort((a, b) => a.pbpa_order - b.pbpa_order)
  }

  const resultsItems = data?.results?.items

  const tableColumns =
  [
      {
          id: "when",
          Header: <Label data="HeaderWhen"/>,
          accessor: 'pbpa_When',
          Cell: (props) => {
            const row = props.cell.row.original
            let val = (row?.pbpa_Comment?.includes('ENDP') || row?.pbpa_Comment?.includes('STARTP')) 
              ? <div className='fw-bold'><SportCode discipline={mirs_discipline} entity='@ActionComment' code={row?.pbpa_Comment} /></div>
              : row?.pbpa_When

            return val
          }
      },
      {
          id: "incident",
          Header: <Label data="HeaderIncident"/>,
          headerClassName: "text-start",
          accessor: 'pbpa_ActionDesc',
          className: "text-start text-wrap "
      },
      {
          id: "boats",
          Header: <Label data="HeaderBoatsInvolved"/>,
          headerClassName: "text-start w-40",
          accessor: 'pbpa_order',
          className: "text-start",
          Cell: (props) => {
            
            const competitors = props.cell.row.original?.competitors?.map((competitor, key) => {
              let competitorItem = resultsItems?.find(item => item.participant?.code === competitor?.pbpc_code)
              //console.log()
              return (
                <ResultCompetitor
                  key={`boat-Involved-${key}`}
                  //bib={competitorItem?.bib}
                  noc={<Noc code={competitorItem?.participant?.organisation?.code} />}
                  competitor={
                    <Competitors
                      name={competitorItem?.participant?.name}
                      shortName={competitorItem?.participant?.shortName}
                      hidePicture={true}
                      noc={competitorItem?.participant?.organisation?.code}
                      code={competitorItem?.participant?.code}
                    />
                  }
                />
              )
            })
            return (
              <>{competitors}</>
            );
          }
      }
  ]

  const columns = useMemo(() => tableColumns, [])

  const captionTable = <CaptionTable leftCol={<Label data="HeaderRaceIncidents" />} />

  return (
    <>
    {actions &&
        < MirsTable
            className='table-result table-race-incidents'
            data={actions}
            columns={columns}
            id={`mirs-table-race-incidents-${mirs_rsc}`}
            caption={captionTable}
        />
    }
    </>
  );
}

export default SalRaceIncidents;